import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import deepEqual from "deep-equal";
import { useApplyFilters } from "../components/elements/SearchResults/components/boundsFilterHooks.js";
import { useSelector } from "react-redux";
import { getSearch } from "../store/search/selectors.js";
export function getUpdatedSearchParams(filters, resetPage = true) {
    const qs = new URLSearchParams(location.search);
    if (filters.stops != undefined) {
        qs.set("stops", "" + filters.stops);
    }
    else {
        qs.delete("stops");
    }
    if (filters.airlines && filters.airlines.length > 0) {
        qs.set("airlines", filters.airlines.join(","));
    }
    else {
        qs.delete("airlines");
    }
    if (filters.duration) {
        qs.set("duration", `${filters.duration}`);
    }
    else {
        qs.delete("duration");
    }
    if (filters.departureIntervals) {
        qs.delete("depInt");
        filters.departureIntervals.forEach((interval) => {
            qs.append("depInt", interval.join("-"));
        });
    }
    else {
        qs.delete("depInt");
    }
    if (filters.arrivalIntervals) {
        qs.delete("arrInt");
        filters.arrivalIntervals.forEach((interval) => {
            qs.append("arrInt", interval.join("-"));
        });
    }
    else {
        qs.delete("arrInt");
    }
    if (filters.flightTimes?.length) {
        qs.delete("depTimeInt");
        qs.delete("arrTimeInt");
        let departures = "";
        let arrivals = "";
        filters.flightTimes.forEach((interval) => {
            const currentDeparture = getflightTimeIntervalSelection(interval.departure);
            const currentArrival = getflightTimeIntervalSelection(interval.arrival);
            departures = departures.length === 0 ? `${currentDeparture}` : `${departures}|${currentDeparture}`;
            arrivals = arrivals.length === 0 ? `${currentArrival}` : `${arrivals}|${currentArrival}`;
        });
        qs.append("depTimeInt", departures);
        qs.append("arrTimeInt", arrivals);
    }
    else {
        qs.delete("depTimeInt");
        qs.delete("arrTimeInt");
    }
    if (filters.shortLayoverConnection) {
        qs.delete("shortLayoverConnection");
        qs.append("shortLayoverConnection", String("1"));
    }
    else {
        qs.delete("shortLayoverConnection");
    }
    if (!!filters.includedBaggage?.length) {
        qs.delete("includedBaggage");
        qs.append("includedBaggage", filters.includedBaggage.join(","));
    }
    else {
        qs.delete("includedBaggage");
    }
    if (!!filters.maxBudget) {
        qs.delete("maxBudget");
        qs.append("maxBudget", String(filters.maxBudget));
    }
    else {
        qs.delete("maxBudget");
    }
    if (!!filters.maxBudgetPerAdult) {
        qs.delete("maxBudgetPerAdult");
        qs.append("maxBudgetPerAdult", String(filters.maxBudgetPerAdult));
    }
    else {
        qs.delete("maxBudgetPerAdult");
    }
    if (!!filters.airports?.length) {
        qs.delete("airports");
        qs.append("airports", filters.airports.join(","));
    }
    else {
        qs.delete("airports");
    }
    if (!!filters.preferSameAirport) {
        qs.delete("preferSameAirport");
        qs.append("preferSameAirport", filters.preferSameAirport);
    }
    else {
        qs.delete("preferSameAirport");
    }
    if (filters.allDeals) {
        qs.delete("showDeals");
        qs.append("showDeals", String(1));
    }
    else {
        qs.delete("showDeals");
    }
    if (!!filters.maxLayoverDuration) {
        qs.delete("maxLayoverDuration");
        qs.append("maxLayoverDuration", String(filters.maxLayoverDuration));
    }
    else {
        qs.delete("maxLayoverDuration");
    }
    if (resetPage) {
        qs.delete("page");
        qs.delete("auto_load_page");
    }
    return qs;
}
const getflightTimeIntervalSelection = (interval) => {
    const selectedIntervals = interval.filter((inter) => inter.selected);
    return selectedIntervals.length > 0
        ? selectedIntervals
            .map((selectedInterval) => {
            const start = selectedInterval.start?.split(":")[0];
            const end = selectedInterval.end?.split(":")[0];
            return `${start}-${end}`;
        })
            .join(",")
        : "00-23";
};
const useSearchFilters = () => {
    const history = useHistory();
    const search = useSelector(getSearch);
    const [currentFilters] = useState(search.filters);
    const applyFiltersBounds = useApplyFilters();
    const updateUrl = useCallback((query) => {
        history.replace({
            pathname: location.pathname,
            search: query.toString()
        }, { hideLoader: true });
    }, [history]);
    const applyFilters = useCallback((filters) => {
        const shouldResetPage = !deepEqual(currentFilters, filters);
        const qs = getUpdatedSearchParams(filters, shouldResetPage);
        applyFiltersBounds();
        updateUrl(qs);
    }, [currentFilters, applyFiltersBounds, updateUrl]);
    return {
        applyFilters
    };
};
export default useSearchFilters;
